import router from 'next/router';
import { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useNews } from '../../../hooks/news';
import { News } from '../../../models/news';
import LoadingCarouselNews from '../../Shimmer/LoadingCarouselNews';

import { Container } from './styles';

function CarouselNews() {
  const { getNews } = useNews();
  const [news, setNews] = useState<News[]>([]);
  const [page] = useState(0);
  const [isLoadingCarrosel, setIsLoadingCarrosel] = useState(true);

  useEffect(() => {
    async function getInitialData() {
      try {
        const news = await getNews(page);
        setNews(news);
        setIsLoadingCarrosel(false);
      } catch (error) {
        setIsLoadingCarrosel(false);
        console.log(error);
      }
    }

    if (page == 0) {
      getInitialData();
    }
  }, [getNews, page]);

  const decodeText = (text: string) => {
    return text
      .replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      })
      .replace(/<p>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/<\/p>/g, '');
  };

  const httpTohttps = (url: string) => {
    return url.replace(/http:/g, 'https:');
  };

  const handleClick = (slug: string) => {
    router.push({
      pathname: `news/${slug}`,
    });
  };

  return (
    <>
      <Container>
        {isLoadingCarrosel ? (
          <LoadingCarouselNews />
        ) : (
          <Carousel
            className="carousel-news"
            infiniteLoop={true}
            showThumbs={false}
            showArrows={true}
            showStatus={false}
            showIndicators={false}
            autoPlay={true}
            interval={9000}
          >
            {(news ?? []).slice(0, 4).map((newsItem, index) => (
              <div
                key={index}
                className="click"
                onClick={() => handleClick(newsItem.slug)}
              >
                <img src={httpTohttps(newsItem.image)} alt="" />
                <img
                  className="background"
                  src={httpTohttps(newsItem.image)}
                  alt="background"
                />
                <h2 className="legend">{decodeText(newsItem.title)}</h2>
              </div>
            ))}
          </Carousel>
        )}
      </Container>
    </>
  );
}

export default CarouselNews;
